import { useSuppressCircuitBreakerActions } from './api/useSuppressCircuitBreakerActions';

export const useAutoPricingResultStateActions = () => {
  const { onSubmit: onSaveSuppressCircuitBreaker } =
    useSuppressCircuitBreakerActions();

  return {
    onSubmits: {
      suppressCircuitBreaker: onSaveSuppressCircuitBreaker,
      // As we support more types of actions, add them here
    },
  };
};
